"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var localization = require("./localization");
var countries = require("../metadata/countries.json");
var locales = require("../metadata/locales.json");
var defaultLocale = 'en-US';
function mapCountry(source, translationLocale) {
    var localizationKey = source['country'].toLowerCase();
    var target = Object.assign({}, source);
    target['englishName'] = localization.get(defaultLocale, 'countries', localizationKey);
    target['translatedName'] = localization.get(translationLocale, 'countries', localizationKey);
    return target;
}
function mapLocale(source, translationLocale, trustpilotHost) {
    var localizationKey = source['locale'].toLowerCase();
    var target = Object.assign({}, source);
    [
        'consumerWebApp',
        'businessWebApp',
        'legalUrl',
        'commercialUrl',
        'aboutTrustpilotUrl',
        'supportUrl',
        'blog',
        'businessSignupUrl'
    ].forEach(function (key) {
        target[key] = target[key].replace('trustpilot.com', trustpilotHost);
    });
    target['nativeName'] = localization.get(source['locale'], 'locales', localizationKey);
    target['translatedName'] = localization.get(translationLocale, 'locales', localizationKey);
    return target;
}
function getCountries(locale) {
    if (locale === void 0) { locale = defaultLocale; }
    var localeObj = localization.parseLocale(locale);
    return {
        countries: countries.map(function (x) { return mapCountry(x, localeObj); })
    };
}
exports.getCountries = getCountries;
function getLocale(locale, translationLocale, trustpilotHost) {
    if (translationLocale === void 0) { translationLocale = defaultLocale; }
    if (trustpilotHost === void 0) { trustpilotHost = 'trustpilot.com'; }
    var translationLocaleObj = localization.parseLocale(translationLocale);
    var localeObj = locales.find(function (x) { return x['locale'].toLowerCase() == locale.toLowerCase(); })
        || locales.find(function (x) { return x['locale'] == defaultLocale; });
    return mapLocale(localeObj, translationLocaleObj, trustpilotHost);
}
exports.getLocale = getLocale;
function getLocales(translationLocale, trustpilotHost) {
    if (translationLocale === void 0) { translationLocale = defaultLocale; }
    if (trustpilotHost === void 0) { trustpilotHost = 'trustpilot.com'; }
    var translationLocaleObj = localization.parseLocale(translationLocale);
    var mappedLocales = locales.map(function (x) { return mapLocale(x, translationLocaleObj, trustpilotHost); });
    return {
        locales: mappedLocales,
        defaultLocale: mappedLocales.find(function (x) { return x['locale'] == defaultLocale; }),
    };
}
exports.getLocales = getLocales;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/resources/services/metadata.js
// module id = 1277
// module chunks = 0